module.exports = {
    "breadcrumbs": `Popis cesty`
};


//# sourceMappingURL=cs-CZ.main.js.map
